import { useRef, useEffect, use } from 'react'

import cn from 'clsx'

import { Button, NavLink } from 'shared-components'

import ImageBox from '../ImageBox/ImageBox'

import BlockArrow from '../../images/blockArrow'

import { getSanityLink } from 'shared-functions'

import s from './Menu.module.sass'

export default function Menu({
    headerMenu,
    menuCta,
    isOpen,
    site,
    hasScrolled,
    headerRef,
}: {
    headerMenu: any
    menuCta: any
    isOpen: boolean
    site?: string
    hasScrolled?: boolean
    headerRef: React.RefObject<HTMLDivElement | null>
}) {
    const menuCtaLink = getSanityLink(menuCta?.link)

    const menuItemRef = useRef<HTMLUListElement>(null)
    const menuItemSubmenuRef = useRef<HTMLUListElement>(null)

    useEffect(() => {
        if (menuItemRef.current) {
            const menuItems = menuItemRef.current.children

            Array.from(menuItems).forEach((item) => {
                const offsetFromRef = (item as HTMLElement).offsetLeft - (headerRef.current?.offsetLeft || 0)
                // Find the submenu for this menu item
                const submenu = (item as HTMLElement).querySelector('ul')
                // Only set offset if submenu does NOT have the .WhatWeDo class
                const submenuContainer = (item as HTMLElement).querySelector(`.${s.Submenu}`)
                if (
                    submenu &&
                    submenuContainer &&
                    (typeof s.WhatWeDo !== 'string' || !submenuContainer.classList.contains(s.WhatWeDo))
                ) {
                    Array.from(submenu.children).forEach((submenuItem) => {
                        const submenuOffset =
                            (submenuItem as HTMLElement).offsetLeft - (headerRef.current?.offsetLeft || 0)
                        let offsetValue = offsetFromRef - submenuOffset - 15
                        if (offsetValue > 265) offsetValue = 265
                        ;(submenuItem as HTMLElement).style.setProperty('--submenu-offset', `${offsetValue}px`)
                    })
                }
            })
        }
    }, [menuItemRef])

    return (
        <nav
            className={cn(
                s.Menu,
                isOpen && s.Open,
                site === 'amos-air' && s.AmosAir,
                site === 'hydro-industries' && s.HydroIndustries,
                hasScrolled && s.HasScrolled,
            )}
        >
            <ul ref={menuItemRef}>
                {site === 'hydro-industries' && (
                    <li>
                        <NavLink href="/">Home</NavLink>
                    </li>
                )}
                {headerMenu?.map((item: any, index: number) => {
                    const { title, children } = item

                    return (
                        <li key={index}>
                            {item?.page?.slug ? (
                                <NavLink href={`/${item?.page?.slug}`}>{title}</NavLink>
                            ) : (
                                <div className={s.Button}>
                                    <span>{title}</span>
                                    {BlockArrow}
                                    {children && children?.length > 0 && (
                                        <>
                                            <div
                                                className={cn(
                                                    s.Submenu,
                                                    title === 'What we do' && s.WhatWeDo,
                                                    children?.length > 3 && s.LongSubmenu,
                                                )}
                                            >
                                                <div className={s.SubmenuCta} style={{ display: 'none' }}>
                                                    {menuCtaLink?.url && (
                                                        <NavLink href={menuCtaLink?.url || '/'}>
                                                            {menuCta?.image && (
                                                                <div className={s.SubmenuCtaImage}>
                                                                    <ImageBox image={menuCta?.image} />
                                                                </div>
                                                            )}
                                                            {menuCta?.title && <h4>{menuCta?.title}</h4>}
                                                            <Button
                                                                title={menuCta?.link?.title || 'Learn More'}
                                                                transparent
                                                                inverted
                                                                small
                                                            />
                                                        </NavLink>
                                                    )}
                                                </div>
                                                <ul style={{ display: 'none' }} ref={menuItemSubmenuRef}>
                                                    {children?.map((child: any, index: number) => {
                                                        if (!child?.slug) return null

                                                        return (
                                                            <li key={index}>
                                                                <NavLink href={`/${child?.slug}`}>
                                                                    {child?.pageLogo ? (
                                                                        <div className={s.SubmenuPageLogo}>
                                                                            <ImageBox
                                                                                image={child?.pageLogo}
                                                                                width={100}
                                                                                height={100}
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        child?.title
                                                                    )}
                                                                    {BlockArrow}
                                                                    <p>{child?.description}</p>
                                                                    <Button title="Learn More" noBorder />
                                                                </NavLink>
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                            <div className={s.HeaderBg} style={{ display: 'none' }} />
                                            <div className={s.Backdrop} style={{ display: 'none' }} />
                                        </>
                                    )}
                                </div>
                            )}
                        </li>
                    )
                })}
                <li>
                    <Button
                        url="/contact"
                        title="Contact"
                        inverted={!(site === 'amos-air')}
                        transparent={site === 'bems'}
                        noArrow
                        small
                    />
                </li>
            </ul>
        </nav>
    )
}
